export enum ModalDismissReasons {
    BackdropClick,
    Esc,
}
